import VBtn from './VBtn';
export { VBtn };
export default VBtn;
//# sourceMappingURL=index.js.map